(function () {
  var SECTION_SELECTOR = '.oddit-section-key-traits-band';
  var sectionState = new Map();

  var MAX_SETS = 24;

  function initMarquee(section) {
    var track = section.querySelector('[data-marquee-track]');
    var firstSet = section.querySelector('[data-marquee-set]');
    var viewport = section.querySelector('[data-marquee]');
    if (!track || !firstSet) return null;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var clones = [];

    function ensureFill(setWidth, trackGap) {
      if (!(setWidth > 0)) return;
      var needed = viewport ? viewport.clientWidth : section.clientWidth;
      var sets = track.children.length;

      while ((sets - 1) * setWidth + (sets - 2) * trackGap < needed && sets < MAX_SETS) {
        var clone = firstSet.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-marquee-set');
        clone.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
        track.appendChild(clone);
        clones.push(clone);
        sets++;
      }
    }

    function measure() {
      var setWidth = firstSet.scrollWidth;
      var trackStyle = getComputedStyle(track);
      var trackGap = parseFloat(trackStyle.columnGap) || parseFloat(trackStyle.gap) || 0;
      ensureFill(setWidth, trackGap);
      var distance = setWidth + trackGap;
      track.style.setProperty('--marquee-distance', '-' + distance + 'px');
    }

    function enable() {
      measure();
      track.style.animationPlayState = 'running';
    }

    function disable() {
      track.style.animationPlayState = 'paused';
    }

    if (reducedMotion.matches) {
      disable();
    } else {
      enable();
    }

    var ro = new ResizeObserver(function () {
      if (!reducedMotion.matches) measure();
    });
    ro.observe(section);

    function onMotionChange(e) {
      e.matches ? disable() : enable();
    }

    function onVisibilityChange() {
      if (reducedMotion.matches) return;
      track.style.animationPlayState = document.hidden ? 'paused' : 'running';
    }

    reducedMotion.addEventListener('change', onMotionChange);
    document.addEventListener('visibilitychange', onVisibilityChange);

    return { measure: measure, ro: ro, clones: clones, reducedMotion: reducedMotion, onMotionChange: onMotionChange, onVisibilityChange: onVisibilityChange };
  }

  function destroyMarquee(state) {
    if (!state) return;
    if (state.ro) state.ro.disconnect();
    if (state.reducedMotion) state.reducedMotion.removeEventListener('change', state.onMotionChange);
    document.removeEventListener('visibilitychange', state.onVisibilityChange);
    if (state.clones) {
      state.clones.forEach(function (c) { if (c.parentNode) c.parentNode.removeChild(c); });
      state.clones.length = 0;
    }
  }

  function initSection(section) {
    var state = { marquee: initMarquee(section) };
    sectionState.set(section.id, state);
  }

  function destroySection(section) {
    var state = sectionState.get(section.id);
    if (!state) return;
    destroyMarquee(state.marquee);
    sectionState.delete(section.id);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();